module.exports = __webpack_public_path__ + "static/media/upi.fd56deb0.png";